// extracted by mini-css-extract-plugin
export var label = "_fy-2";
export var slideContainer = "_fy-0";
export var slider = "_fy-1";